<div class="feedback-section">
  <span class="body-03 timestamp-text">{{
    feedback.updatedAt ? (feedback.updatedAt | date: 'y-MMM-d h:mm a') : ''
  }}</span>
</div>
<div class="feedback-section feedback-title-section">
  <mat-icon
    [svgIcon]="feedback.iconName || 'otherFeedback'"
    class="material-symbols-outlined feedback-type-icon"
  ></mat-icon>

  <div class="title-container subtitle-03">
    <span class="title-text"> {{ feedback.title }}</span>
    <span class="body-03 footer-text">{{ footerText$ | async }}</span>
  </div>
  <mat-icon svgIcon="solvedMarker" *ngIf="feedback.isClosed"></mat-icon>
  <button
    mat-icon-button
    [matMenuTriggerFor]="menu"
    *ngIf="isMenuDisplayed$ | async"
    #trigger="matMenuTrigger"
  >
    <mat-icon class="material-symbols-outlined">more_vert</mat-icon>
    <mat-menu #menu="matMenu">
      <button
        mat-menu-item
        (click)="editFeedback()"
        [disabled]="hasSampleFinalized$ | async"
      >
        Edit
      </button>
      <button mat-menu-item (click)="deleteFeedback(feedback, $event, trigger)">
        Delete
      </button>
    </mat-menu>
  </button>
</div>

@if (feedback.comment) {
  <span class="subtitle-03 feedback-comment">{{ feedback.comment }}</span>
}
